import { render, staticRenderFns } from "./ModalAlertLayout.vue?vue&type=template&id=3a9182f0&scoped=true&"
import script from "./ModalAlertLayout.vue?vue&type=script&lang=js&"
export * from "./ModalAlertLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertLayout.vue?vue&type=style&index=0&id=3a9182f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9182f0",
  null
  
)

export default component.exports